export const LOGIN_CAPTION = 'Log in to manage employee benefits';
